import React from 'react'

function ProgressBar({ current, total, status, onCancel }) {
  const percent = total > 0 ? Math.round((current / total) * 100) : 0

  return (
    <div className="progress-container">
      <div className="progress-bar-wrapper">
        <div className="progress-bar" style={{ width: `${percent}%` }}></div>
      </div>
      <span className="progress-text">
        {current}/{total} ({percent}%)
      </span>
      {status && (
        <span className="progress-status">{status}</span>
      )}
      {onCancel && (
        <button onClick={onCancel} className="btn btn-secondary btn-sm">
          Cancel
        </button>
      )}
    </div>
  )
}

export default ProgressBar
